import cn from "classnames";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import { GITHUB_CLIENT_URL, GOOGLE_CLIENT_URL } from "utils/url.utils";
import { GithubIcon, GoogleIcon } from "../Icons";
import { Link } from "../Link";
import style from "./SocialLogin.module.scss";

export const SocialLogin = () => {
  const { siteName } = useSiteName();
  return (
    <div className={style.socialLoginButtons}>
      <Link
        className={cn(style.socialLoginButton, {
          [style.socialLoginButtonChineseBrothers]: siteName === SITE_NAME.CHINESE_BROTHERS,
        })}
        href={GOOGLE_CLIENT_URL}
        text="Sign in with Google"
      >
        <GoogleIcon className={style.socialLoginIcon} />
      </Link>
      <Link
        className={cn(style.socialLoginButton, {
          [style.socialLoginButtonChineseBrothers]: siteName === SITE_NAME.CHINESE_BROTHERS,
        })}
        href={GITHUB_CLIENT_URL}
        text="Sign in with GitHub"
      >
        <GithubIcon className={style.socialLoginIcon} />
      </Link>
    </div>
  );
};
